/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const title = {
  fontSize: '24px',
  // fontFamily: "Open Sans",
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '32px'
};

const body1 = {
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '24px'
};

const body2 = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '18px'
};

const subtitle1 = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '20px'
};

const button = {
  color: '#5564F8',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '24px'
};

const CTitle = (props) => {
  return <Title style={{ ...title, ...props.xstyle }} {...props} />;
};

const CBody1 = (props) => {
  return <Text style={{ ...body1, ...props.xstyle }} {...props} />;
};

const CBody2 = (props) => {
  return <Text style={{ ...body2, ...props.xstyle }} {...props} />;
};

const CSubtitle1 = (props) => {
  return <Text style={{ ...subtitle1, ...props.xstyle }} {...props} />;
};

const CButton = (props) => {
  return <Text style={{ ...button, ...props.xstyle }} {...props} />;
};

export { CTitle, CBody1, CBody2, CSubtitle1, CButton };
